import {useGetCurrentUser} from "api/api-hooks/user-hooks";
import {useGetProjectQuery, useGetUserSettingsQuery} from "gql/generated/types";
import {useParams} from "react-router-dom";
import {validate} from "uuid"

export default function useProjectContext() {
  const { projectId } = useParams();
  if (!validate(projectId!)) throw new Error("Invalid project id format in url");
  const {data: user} = useGetCurrentUser();
  const { data: userSettings } = useGetUserSettingsQuery({
    variables: { id: projectId! },
  });
  const { data: project } = useGetProjectQuery({
    variables: { id: projectId! },
  });
  
  return { projectId, user, userSettings, project } as const;
}